import { Component, OnInit, Input, SimpleChanges } from '@angular/core';
import { Observable } from 'rxjs';
import * as moment from 'moment';
import { LogbookService } from '../../../services/logbook.service';
import { environment } from '../../../../environments/environment';
import Swal, {SweetAlertIcon} from 'sweetalert2';
import { FilesService } from '../../../services/files.service';
import { StationService } from '../../../services/stations.service';
import { LocalDataSource } from 'ng2-smart-table';
import { ActivatedRoute } from '@angular/router';
import { permitDownload } from '../../../helpers/permissions';
const lodash = require('lodash');
const Lockr = require('lockr');

@Component({
  selector: 'ngx-logbooks',
  templateUrl: './logbooks.component.html',
  styleUrls: ['./logbooks.component.scss'],
})
export class LogbooksComponent implements OnInit {
  @Input() stationId: string;
  @Input() type: number;
  @Input() startDate: string;
  @Input() endDate: string;
  @Input() events: Observable<void>;
  url = environment.baseEndpoint;
  logbooks: any = [];
  inspectionLogbooks: any = [];
  manteinenceLogbooks: any = [];
  manteinenceLogbooksBackup: any = [];
  productLogbooks: any = [];
  receptionLogbooks: any = [];
  batteryCheckLogbooks: any = [];
  eventsNOM005SCFILogbooks: any = [];
  extinguisherLogbooks: any = [];
  dangerousResiduesLogbooks: any = [];
  cleanupContaminatedSitesLogbooks: any = [];
  airtightnessLogbooks: any = [];
  airtightnessTanksLogbooks: any = [];
  airtightnessPrimaryLogbooks: any = [];
  airtightnessSecondaryLogbooks: any = [];
  schedulesCleaningsLogbooks: any = [];
  schedulesCleaningsDailyLogbooks: any = [];
  schedulesCleaningsMonthlyLogbooks: any = [];
  schedulesCleaningsQuarterlyLogbooks: any = [];
  incidentsAndInspectionsLogbooks: any = [];
  incidentsAndInspectionsOperationLogbooks: any = [];
  incidentsAndInspectionsMantenianceLogbooks: any = [];
  typeProductSelected = 'all';
  logbooksCopy = [];
  description_type: string;
  downloadUrl: string = '';
  loading: boolean = false;
  range: any;
  fields: Array<string> = [];
  eventsSubscription: any;
  moment = moment;
  years = [];
  paramsFolioNew = {
    year: moment().year(),
    type: 0,
    typeFolio: 'type',
  };
  sourceStandardProducts: LocalDataSource;
  sourcePremiumProducts: LocalDataSource;
  sourceDieselProducts: LocalDataSource;
  settings: any = {
    mode: 'external',
    edit: {
      editButtonContent: '<img src="assets/images/icons/edit.png" class="mx-2" width="20px">',
    },
    delete: {
      deleteButtonContent: '<img src="assets/images/icons/delete.png" class="mx-2" width="20px">',
    },
    actions: {
      columnTitle: '',
      position: 'right',
      add: false,
    },
    pager: {
      perPage: 50,
    },
    columns: {
      folio: {
        title: 'Folio',
        filter: true,
      },
      date: {
        title: 'Fecha',
        filter: true,
      },
      start_time: {
        title: 'Hora inicio',
        filter: true,
      },
      end_time: {
        title: 'Hora término',
        filter: true,
      },
      previous_volume: {
        title: 'Volumen inicial (A)',
        filter: false,
      },
      reception_volume: {
        title: 'Volumen de recepción (B)',
        filter: false,
      },
      tank_return: {
        title: 'Devolución al tanque (E)',
        filter: false,
      },
      sell_volume: {
        title: 'Volumen de venta (F)',
        filter: false,
      },
      end_volume: {
        title: 'Volumen final (G)',
        filter: false,
      },
      start_volume: {
        title: 'Inventario Final Calculado (H = A+B+C*+E-F-D*)',
        filter: false,
      },
      fuel_lost: {
        title: 'Perdida de combustible (G-H)',
        filter: false,
      },
    },
    noDataMessage: 'Sin registros',
  };
  dataLoaded = false;
  logbookType: number;
  filtersByPermission = [
    {
      label: 'Trabajos en altura',
      value: 'trabajo_altura'
    },
    {
      label: 'Trabajos en caliente',
      value: 'trabajo_caliente'
    },
    {
      label: 'Trabajos de mantenimiento general',
      value: 'trabajo_mantenimiento_general'
    },
    {
      label: 'Trabajos en espacios confinados',
      value: 'espacios_confinados'
    },
  ]
  filtersByPermissionSelected = []

  constructor(
    private logbookService: LogbookService,
    private fileService: FilesService,
    private stationService: StationService,
    private route: ActivatedRoute,
    ) {
    this.range = {
      startDate: moment().startOf('month'),
      endDate: moment().endOf('month'),
    };
    this.stationId =  this.route.snapshot.params.stationId;

    this.stationService.change.subscribe(async (station: any) => {
      this.stationId = station;
      this.getLogbooks();
    });
  }

  ngOnInit() {
    this.init();
  }

  init() {
    const currentYear = moment().year()
    for (let index = 0; index < 6; index++) {
      this.years.push(currentYear - index)
    }
    this.eventsSubscription = this.events.subscribe((range: any) => {
      this.range = range.range;
      this.getLogbooks();
    });
  }

  // tslint:disable-next-line: use-lifecycle-interface
  ngOnChanges(changes: SimpleChanges) {
    if (changes.type) {
      changes.type.currentValue !== changes.type.previousValue ? this.getLogbooks() : 0;
      if (changes.type.currentValue === 1) this.description_type = 'mantenimiento';
      if (changes.type.currentValue === 2) this.description_type = 'accidentes e incidentes';
      if (changes.type.currentValue === 3) this.description_type = 'recepción y descarga';
      if (changes.type.currentValue === 4) this.description_type = 'desviación en el balance de producto';
      if (changes.type.currentValue === 5) this.description_type = 'revisión de baterías';
      if (changes.type.currentValue === 6) this.description_type = 'Apertura de puertas';
      if (changes.type.currentValue === 7) this.description_type = 'Residuos peligrosos';
      if (changes.type.currentValue === 8) this.description_type = 'Limpieza de sitios contaminados';
      if (changes.type.currentValue === 9) this.description_type = 'Extintores';
      if (changes.type.currentValue === 10) this.description_type = 'Limpiezas programadas y no programadas';
      if (changes.type.currentValue === 11) this.description_type = 'Hermeticidad';
      if (changes.type.currentValue === 12) this.description_type = 'Incidentes e inspecciones';
      // tslint:disable-next-line: max-line-length
      this.downloadUrl = `${environment.baseEndpoint}/fileGenerator?stationId=${this.stationId}&documentType=bitacoras&logbookType=${changes.type.currentValue}`;
    }
  }

  async getLogbooks() {
    this.type = Number(this.type);
    this.inspectionLogbooks = [];
    this.manteinenceLogbooks = [];
    this.manteinenceLogbooksBackup = [];
    this.productLogbooks = [];
    this.receptionLogbooks = [];
    this.batteryCheckLogbooks = [];
    this.loading = true;
    const rangeCache = localStorage.getItem('range_data_selected')
    if (rangeCache) {
      const dateAuxCache = JSON.parse(rangeCache)
      this.range.startDate = moment(dateAuxCache.startDate)
      this.range.endDate = moment(dateAuxCache.endDate)
    }
    const [error, { data: logbooks }]: any = await this.logbookService.getLogbooks(this.stationId, this.type, this.range);
    this.loading = false;
    const logbookFormatted = await lodash.orderBy(logbooks, ['folio'], ['asc']);
    const logbooksToRemove = []
    // If date moved from annual programm
    logbookFormatted.forEach(async (logbook, index) => {
      if (logbook.event_id || logbook.cleaning_event_id) logbook.isLogbookProgramAnnual = true

      if (moment(logbook.date) < moment(this.range.startDate) || moment(logbook.date) > moment(this.range.endDate)) {
        logbooksToRemove.push(index)
      }
      logbook.originalImage = logbook.image;
      logbook.image = logbook.image ? await this.getImageOrFallback(logbook.image) : logbook.image;
      if (this.type === 1  && logbook.others_images) {
        const others_images = [];
        for (let index = 0; index < logbook.others_images.length; index++) {
          const image_url = logbook.others_images[index];
          const url = await this.getImageOrFallback(image_url);
          others_images.push({
            originalPath: image_url,
            url: url,
          });
        }
        logbook.others_images = others_images;
      }
      if (this.type === 7 && logbook.others_images) {
        const others_images = [];
        for (let index = 0; index < logbook.others_images.length; index++) {
          const image_url = logbook.others_images[index];
          const url = await this.getImageOrFallback(image_url);
          others_images.push({
            originalPath: image_url,
            url: url,
          });
        }
        logbook.others_images = others_images;
      }
    });

    logbooksToRemove.forEach((index) => {
      logbookFormatted.splice(index, 1);
    });

    this.logbooksCopy = logbookFormatted;
    if (error) return error;
    if (this.type === 1) {
      this.manteinenceLogbooks = logbookFormatted;
      this.manteinenceLogbooksBackup = logbookFormatted;
    } else if (this.type === 2) this.inspectionLogbooks = logbookFormatted;
      else if (this.type === 3) this.receptionLogbooks = logbookFormatted;
      else if (this.type === 4) {
      const standardProducts = [];
      const premiumProducts = [];
      const dieselProducts = [];
      this.productLogbooks = logbookFormatted;
      for await (const logbook of logbookFormatted) {
        if (logbook.fields.product === 'standard') await standardProducts.push({ ...logbook, ...logbook.fields });
        if (logbook.fields.product === 'premium') await premiumProducts.push({ ...logbook, ...logbook.fields });
        if (logbook.fields.product === 'diesel') await dieselProducts.push({ ...logbook, ...logbook.fields });
      }
      this.sourceStandardProducts = new LocalDataSource(standardProducts);
      this.sourcePremiumProducts = new LocalDataSource(premiumProducts);
      this.sourceDieselProducts = new LocalDataSource(dieselProducts);
      } else if (this.type === 5) this.batteryCheckLogbooks = logbookFormatted;
      else if (this.type === 6) this.eventsNOM005SCFILogbooks = logbookFormatted;
      else if (this.type === 7) this.dangerousResiduesLogbooks = logbookFormatted;
      else if (this.type === 8) this.cleanupContaminatedSitesLogbooks = logbookFormatted;
      else if (this.type === 9) this.extinguisherLogbooks = logbookFormatted;
      else if (this.type === 10) {
        this.schedulesCleaningsLogbooks = logbookFormatted;
        this.schedulesCleaningsDailyLogbooks = logbookFormatted.filter(logbook => logbook.fields.period === 'daily');
        this.schedulesCleaningsMonthlyLogbooks = logbookFormatted.filter(logbook => logbook.fields.period === 'monthly');
        this.schedulesCleaningsQuarterlyLogbooks = logbookFormatted.filter(logbook => logbook.fields.period === 'quarterly');
      } else if (this.type === 11) {
        this.airtightnessLogbooks = logbookFormatted;
        this.airtightnessTanksLogbooks = logbookFormatted.filter(logbook => logbook.fields.type_air_tightness === 'tanks');
        this.airtightnessPrimaryLogbooks = logbookFormatted.filter(logbook => logbook.fields.type_air_tightness === 'product-lines-primary-pipe');
        this.airtightnessSecondaryLogbooks = logbookFormatted.filter(logbook => logbook.fields.type_air_tightness === 'product-lines-secondary-pipe');
      } else if (this.type === 12 ) {
        this.incidentsAndInspectionsLogbooks = logbookFormatted;
        this.incidentsAndInspectionsOperationLogbooks = logbookFormatted.filter(logbook => logbook.fields.type_logbook === 'operation');
        this.incidentsAndInspectionsMantenianceLogbooks = logbookFormatted.filter(logbook => logbook.fields.type_logbook === 'maintenance');
      }else return console.error('no entra en el tipo de bitacoras [Error. Lista Blanca]');
    this.setFieldsLogbookTable();
  }

  async filterByProduct() {
    if (this.typeProductSelected === 'all') return this.productLogbooks = this.logbooksCopy;
    this.productLogbooks = this.logbooksCopy.filter(logbook => this.typeProductSelected === logbook.fields.product);
  }

  setFieldsLogbookTable() {
    if (this.description_type === 'mantenimiento') {
      this.fields = ['descripción', 'Elemento constructivo, equipo, sistema o instalación'];
    } else if (this.description_type === 'accidentes e incidentes') {
      this.fields = ['descripción', 'Ubicación del incidente', 'Tipo de inspección'];
    } else if (this.description_type === 'recepción y descarga') {
      this.fields = ['empresa', 'producto', 'cantidad', 'observaciones', 'no. unidad'];
    } else {
      // tslint:disable-next-line: max-line-length
      this.fields = ['Volumen Descarga', 'Volumen final', 'Pérdida de producto', 'Producto', 'Volumen recepcion', 'Volumen de venta', 'Volumen inicial'];
    }
  }

  getEquipment() {
    return 0;
  }

  edit(logbook: any) {
    this.logbookService.openEditLogbook()
    this.logbookService.sendDataToEditLogbook({
      stationId: this.stationId,
      logbook: logbook,
      logbookType: logbook.type,
    })
  }

  async downloadFile(value_field: string = '', fileType = 'docx') {
    if (!permitDownload(this.stationId)) {
      await Swal.fire(
        'Contacta al equipo E-Mecsa para realizar esta acción',
        '',
        'warning',
      );
      return;
    }

    const diffDays = Math.round(moment(this.endDate).diff(moment(this.startDate, 'YYYY-MM-DD'), 'days', true))
    if (diffDays > 32) {
      await Swal.fire(
        'Oops',
        'No se pueden descargar bitacoras con un rango mayor a 31 días',
        'question',
      );
      return;
    }

    // /logbook/:stationId/:logbookType
    const column_field = await this.getColumnFieldForDownloadFile();
    const baseUrl = fileType === 'pdf' ? environment.baseEndpointPHP : environment.baseEndpoint;
    const url = `${baseUrl}/filesGeneratorv2/logbook/${this.stationId}/${this.type}`;
    let queryParams = `?startDate=${this.startDate}&endDate=${this.endDate}&column_field=${column_field}&value_field=${value_field}`;
    queryParams = fileType === 'pdf' ? `${queryParams}&pdf=true` : queryParams;
    const nameDoc = `bitacoras_${this.type}_${this.startDate}_${moment(this.endDate).format('ll')}`;
    /* this.loading = true; */
    Swal.fire({
      title: 'Iniciando descarga',
      allowEscapeKey: false,
      allowOutsideClick: false,
      onOpen: () => {
        Swal.showLoading();
      }
    });

    await this.fileService.downloadFile((url + queryParams), nameDoc, fileType);

    Swal.close();
    /* this.loading = false; */
  }

  async getColumnFieldForDownloadFile() {
    switch (this.type) {
      case 4:
        return 'product';
      case 11:
        return 'type_air_tightness';
      case 10:
        return 'period';
      case 12:
        return 'type_logbook';
      default:
        return '';
    }
  }

  async downloadFileAuthTypeActivity(logbook) {
    const url = `${environment.baseEndpointPHP}/filesGeneratorv2/logbook-helper/${this.stationId}/${logbook.id}/${logbook.fields.typeActivity}?pdf=true`;
    const nameDoc = `bitacora_${logbook.fields.typeActivity}`;
    this.loading = true;
    await this.fileService.downloadFile((url), nameDoc, 'pdf');
    this.loading = false;
  }

  async getCopyForUpdateFoliosForColumnAndType(type: string) {
    const typesLogbooks = [
      'Desviación en el balance de producto',
      'Hermeticidad',
      'Limpiezas programas y no programadas',
      'Incidentes e inspecciones',
    ];
    switch (type) {
      case 'standard':
        return { productName: '87 Octanos', typeName: typesLogbooks[0] };
      case 'premium':
        return { productName: '91 Octanos', typeName: typesLogbooks[0] };
      case 'diesel':
        return { productName: 'Diesel', typeName: typesLogbooks[0] };
      case 'tanks':
        return { productName: 'Tanques', typeName: typesLogbooks[1] };
      case 'product-lines-primary-pipe':
        return { productName: 'Líneas de producto tubería primaria', typeName: typesLogbooks[1] };
      case 'product-lines-secondary-pipe':
        return { productName: 'Líneas de producto tubería secundaria', typeName: typesLogbooks[1] };
      case 'daily':
        return { productName: 'Diaria', typeName: typesLogbooks[2] };
      case 'monthly':
        return { productName: 'Mensual', typeName: typesLogbooks[2] };
      case 'quarterly':
        return { productName: 'Trimestral', typeName: typesLogbooks[2] };
      case 'operation':
        return { productName: 'Operación', typeName: typesLogbooks[3] };
      case 'maintenance':
        return { productName: 'Mantenimiento', typeName: typesLogbooks[3] };
      default:
        return {productName: '', typeName: ''};
    }
  }

  async folioNewAllColumnAndType(column_field: string, value_field: string) {
    const copy = await this.getCopyForUpdateFoliosForColumnAndType(value_field);
    await Swal.fire({
      title: '¿Estas seguro?',
      text: `Actualizará los folios de ${copy.productName} de las bitacoras de "${copy.typeName}" creadas en ${this.paramsFolioNew.year}. Esta acción no se puede revertir.`,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, estoy seguro',
      cancelButtonText: 'Cancelar',
    }).then(async (result) => {
      if (result.value) {
        this.loading = true;
        const [error] = await this.logbookService.folioNewAllProduct(this.stationId, this.type, { year: this.paramsFolioNew.year, column_field, value_field });
        this.loading = false;
        if (error) return error;
        await this.getLogbooks();
        await Swal.fire(
          'Bitácoras foliadas',
          '',
          'success',
        );
      }
    });
  }

  async folioNewAll() {
    let typeName = '';
    if (this.type === 1) typeName = 'Mantenimiento';
    if (this.type === 2) typeName = 'Accidentes e incidentes';
    if (this.type === 3) typeName = 'Recepción y descarga';
    if (this.type === 4) typeName = 'Desviación en el balance de producto';
    if (this.type === 5) typeName = 'Revisión de baterías';
    if (this.type === 6) typeName = 'Apertura de puertas';
    if (this.type === 7) typeName = 'Residuos peligrosos';
    if (this.type === 8) typeName = 'Limpieza de sitios contaminados';
    if (this.type === 9) typeName = 'Extintores';
    if (this.type === 11) typeName = 'Hermeticidad';
    await Swal.fire({
      title: '¿Estas seguro?',
      text: `Actualizará los folios de las bitacoras de "${typeName}" creadas en ${this.paramsFolioNew.year}. Esta acción no se puede revertir.`,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si, estoy seguro',
      cancelButtonText: 'Cancelar',
    }).then(async (result) => {
      if (result.value) {
        this.loading = true;
        const [error] = await this.logbookService.folioNewAll(this.stationId, this.type, { year: this.paramsFolioNew.year });
        this.loading = false;
        if (error) return error;
        await this.getLogbooks();
        await Swal.fire(
          'Bitácoras foliadas',
          '',
          'success',
        );
      }
    });
  }

  async onCustomEdit(event: any) {
    const logbook = await this.productLogbooks.find(logbookAux => logbookAux.id === event.data.id);
    this.logbookService.openEditLogbook()
    this.logbookService.sendDataToEditLogbook({
      stationId: this.stationId,
      logbook: logbook,
      logbookType: logbook.type,
    })
    /* this.dialogService.open(EditLogbookComponent, {
      hasScroll: true,
      context: {
        stationId: this.stationId,
        logbook: logbook,
        logbookType: logbook.type,
      },
    }).onClose.subscribe(logbookUpdated => logbookUpdated ? this.getLogbooks() : this.getLogbooks()); */
  }

  async deleteLogbookNormal (logbook: any) {
    Swal.fire({
      title: '<strong>Estas seguro ?</strong>',
      icon: 'warning',
      html: 'Esta acción no se puede revertir',
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar',
    }).then(async (deleted: any) => {
      if (deleted.isDismissed) return
      this.loading = true;
      if (deleted.isConfirmed) {
        const [errorDelete] = await this.logbookService.delete(logbook.id)
        if (errorDelete) {
          this.loading = false;
          return this.alert('Oops', 'error', 'Error al intentar borrar bitacora [BN]');
        }
      }
      await this.getLogbooks();
      this.loading = false;
      await this.alert('Éxito', 'success', 'Bitacora borrada con éxito');
    });
  }

  async delete(event) {
    const logbook = event.data ? event.data : event
    // type 4 = Desviaciones de balance
    if (logbook.type !== 4) return this.deleteLogbookNormal(logbook)
    this.loading = true;
    const [error, { data: nextLogbook }] = await this.logbookService.getNextVolumeProduct(logbook.station_id, logbook.fields.product, logbook.date, logbook.start_time);
    this.loading = false;
    if (error) return this.alert('Oops', 'error', 'Error al intentar borrar bitacora [NL]');
    // next logbook is affected
    let message = '';
    let options = {};
    if (nextLogbook && nextLogbook.fields.previous_volume !== logbook.fields.previous_volume) {
      const nextLogbookClone = await lodash.cloneDeep(nextLogbook);
      const nextLogbookRecalculate = await this.calculateValues(logbook, nextLogbook);
      message = `
      <p><strong>La siguiente bitacora podría sufrir cambios</strong></p>
      <table class="table mt-3">
        <thead>
          <tr style="font-size: 0.7em;">
            <th scope="col"></th>
            <th scope="col">Folio</th>
            <th scope="col">Fecha</th>
            <th scope="col">Volumen de recepción (B)</th>
            <th scope="col">Devolución al tanque (C)</th>
            <th scope="col">Volumen de venta (D)</th>
            <th scope="col">Hora inicio</th>
            <th scope="col">Volumen inicial (A)</th>
            <th scope="col">Hora término</th>
            <th scope="col">Volumen final (F)</th>
            <th scope="col">Inventario final calculado(E) = (A+B+C-D)</th>
            <th scope="col">Perdida de combustible (F-E)</th>
          </tr>
        </thead>
        <tbody style="font-size: 0.9em;">
          <tr class="text-danger-progess-bar">
            <td><i class="fas fa-times fa-2x text-danger"></i></td>
            <td>${nextLogbookClone.folio}</td>
            <td>${nextLogbookClone.date}</td>
            <td>${nextLogbookClone.fields.reception_volume}</td>
            <td>${nextLogbookClone.fields.tank_return}</td>
            <td>${nextLogbookClone.fields.sell_volume}</td>
            <td>${nextLogbookClone.start_time}</td>
            <td>${nextLogbookClone.fields.previous_volume}</td>
            <td>${nextLogbookClone.end_time}</td>
            <td>${nextLogbookClone.fields.end_volume}</td>
            <td>${nextLogbookClone.fields.start_volume}</td>
            <td>${nextLogbookClone.fields.fuel_lost}</td>
          </tr>
          <tr class="text-success-progess-bar">
            <td><i class="fas fa-check fa-2x text-success-progess-bar"></i></td>
            <td>${nextLogbookRecalculate.folio}</td>
            <td>${nextLogbookRecalculate.date}</td>
            <td>${nextLogbookRecalculate.fields.reception_volume}</td>
            <td>${nextLogbookRecalculate.fields.tank_return}</td>
            <td>${nextLogbookRecalculate.fields.sell_volume}</td>
            <td>${nextLogbookRecalculate.start_time}</td>
            <td>${nextLogbookRecalculate.fields.previous_volume}</td>
            <td>${nextLogbookRecalculate.end_time}</td>
            <td>${nextLogbookRecalculate.fields.end_volume}</td>
            <td>${nextLogbookRecalculate.fields.start_volume}</td>
            <td>${nextLogbookRecalculate.fields.fuel_lost}</td>
          </tr>
        </tbody>
      </table>
      `;
      options = {
        customClass: { popup: 'swal2-popup-custom-width' },
        showDenyButton: true,
        denyButtonText: 'Borrar y actualizar bitacora',
        confirmButtonText: 'Solo borrar',
      };
    } else {
      message = 'Esta acción no se puede revertir';
    }

    Swal.fire({
      title: '<strong>Estas seguro ?</strong>',
      icon: 'warning',
      html: message,
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: 'Borrar',
      cancelButtonText: 'Cancelar',
      ...options,
    }).then(async (result) => {
      this.loading = true;
      let errorDelete = null;
      if (result.isDenied) [errorDelete] = await this.logbookService.delete(logbook.id);
      // delete and update
      if (result.isConfirmed) [errorDelete] = await this.logbookService.delete(logbook.id, 1);

      if (result.isDismissed) return this.getLogbooks();


      if (errorDelete)  return this.alert('Oops', 'error', 'Error al intentar borrar bitacora [BE]');
      await this.getLogbooks();

      Swal.fire({
        title: 'Desea actualizar folios',
        icon: 'info',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: 'Actualizar',
        cancelButtonText: 'Cancelar',
      }).then(async (updateFolios: any) => {
        this.loading = true;

        if (updateFolios.isConfirmed) {
          this.paramsFolioNew.year = moment(logbook.date).year();
          await this.folioNewAllColumnAndType('product', logbook.fields.product);
        }
        if (result.isDismissed) await this.getLogbooks();
        this.loading = false;
        await this.alert('Éxito', 'success', 'Bitacora borrada con éxito');
      });
    });
  }

  async calculateValues(logbook, nextLobook) {
    nextLobook.fields.previous_volume = logbook.fields.previous_volume;
    nextLobook.fields.start_volume = await (Number(nextLobook.fields.previous_volume) + Number(nextLobook.fields.tank_return) + Number(nextLobook.fields.reception_volume)) - Number(nextLobook.fields.sell_volume);
    nextLobook.fields.fuel_lost = await Number(nextLobook.fields.end_volume) - Number(nextLobook.fields.start_volume);
    return nextLobook;
  }

  async alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    await Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }

  async selectTypeFuel(e) {
    console.log(e.tabTitle);
    Lockr.set('activeFuelType', e.tabTitle);
  }

  getImageOrFallback (path) {
    return new Promise(resolve => {
      const img = new Image();
      img.src = path;
      img.onload = () => resolve(path);
      img.onerror = () => resolve('https://freeiconshop.com/wp-content/uploads/edd/document-download-flat.png');
    });
  };

  filterMtoByPermission () {
    if (this.filtersByPermissionSelected.length) {
      this.manteinenceLogbooks = this.manteinenceLogbooksBackup.filter(logbook => {
        return this.filtersByPermissionSelected.includes(logbook.fields.typeActivity)
      })
    } else this.manteinenceLogbooks = this.manteinenceLogbooksBackup
  }

}
